"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftApprovalDocumentBuilder = void 0;
var LogRelatedId_1 = require("../common/LogRelatedId");
var NftApprovalDocumentBuilder = /** @class */ (function () {
    function NftApprovalDocumentBuilder() {
    }
    NftApprovalDocumentBuilder.build = function (approval, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: LogRelatedId_1.LogRelatedId.create(chain, approval.transactionHash, approval.logIndex),
            transactionHash: approval.transactionHash,
            contract: approval.contract,
            logIndex: approval.logIndex,
            operator: approval.operator,
            account: approval.account,
            approvedAll: approval.approvedAll,
            tokenId: approval.tokenId,
            tokenContractType: approval.tokenContractType,
            tokenName: approval.tokenName,
            tokenSymbol: approval.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
        };
        return document;
    };
    return NftApprovalDocumentBuilder;
}());
exports.NftApprovalDocumentBuilder = NftApprovalDocumentBuilder;
//# sourceMappingURL=NftApprovalDocumentBuilder.js.map